function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LibyaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#55BA07",
      d: "M0 16.5h24V21H0v-4.5Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#1D1D1D",
      d: "M0 7.5h24v9H0v-9Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#E11C1B",
      d: "M0 3h24v4.5H0V3Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M11.848 14.3c-1.344-.278-1.686-1.081-1.671-2.166 0-1.148.597-2.21 1.658-2.337 1.06-.127 1.928.268 2.383.82-.38-1.498-1.642-1.662-2.61-1.662-1.458-.013-2.997.996-2.997 3.291 0 2.053 1.362 3.069 3.04 3.102 2.096 0 2.424-1.448 2.485-1.941a3.748 3.748 0 0 0-.351.3c-.42.388-.877.811-1.937.592Zm3.313-2.89-.957.37.993.44-.035 1.161.753-.802 1.094.226-.664-.89.579-.857-.913.193-.646-.73-.204.89Z"
    })]
  })]
}));
//# sourceMappingURL=Libya.js.map